import React, { useState, useEffect } from "react";
import { Title } from "../../components/title/title.component";
import { Grid} from "@mui/material";
import "./subscribe.styles.scss";
import InputSelect from "../../components/input-select/input-select.component";
import { getDays, getMonths, getYears } from "../../utils/getData";
//import { Link } from "react-router-dom";
import Button from "../../components/button/button.component";
import { addError } from "../../utils/generaFunctions";


export const Subscribe = (props) => {
    const gift = window.sessionStorage.getItem("gift")? "yes" : props.gift?"yes":"";
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    if(gift) urlParams.set("gift",gift);
    const [title] = useState(`Let's start! When is the ${gift?"wedding":"big day"}?`);
    const [subTitle] = useState(`${gift?"Enter the wedding date to curate themes & frequency, or add the wedding date later.":
                                "The themes of boxes and frequency will be aligned to your wedding planning timeline. You can always update this later if you need to."}`);
    const years = getYears();
    const months = getMonths();
    const [days, setDays] = useState(getDays());
    const [chosenDate, setChosenDate] = useState({year:"", month:"", day:""});
    const [url, setUrl] = useState("");

    useEffect(()=>{
        setUrl("");
        const errorMessage = "Oops! Please enter a date in the future.";
        const now = new Date();
        now.setHours(0,0,0,0);
        const nowArr = {year: now.getFullYear(), month: now.getMonth()+1, day: now.getDate()}
        let error = false;
        if(chosenDate.year && chosenDate.month){
            if(chosenDate.year === nowArr.year && chosenDate.month <= nowArr.month){
                if(chosenDate.month < nowArr.month) error = true;
                else if(chosenDate.day && chosenDate.day < nowArr.day) error = true;
            }
            let day = chosenDate.day;

            if(!day) day=days[days.length-1].value;
            if(error) {
                addError(document.getElementById("the-last-input"), errorMessage)
            } else {
                let weddingDate = new Date(`${chosenDate.year}/${chosenDate.month}/${day}`);
                let daysBetween = (weddingDate.getTime() - now.getTime()) / (1000 * 3600 * 24); 
                urlParams.set("weddingDate",`${chosenDate.year}-${("0"+chosenDate.month).slice(-2)}-${chosenDate.day?("0"+chosenDate.day).slice(-2):day}`)
                setUrl(`${chooseUrl(daysBetween, gift)}&${urlParams.toString()}`);
            }
        }
    },[chosenDate, days, gift]);

    useEffect(()=>{
        if(chosenDate.month === 2){
            let d = new Date(chosenDate.year, chosenDate.month-1, 29);
            let yearMatches = d.getUTCFullYear() === chosenDate.year;
            let monthMatches = d.getUTCMonth() === chosenDate.month-1;
            let dayMatches = d.getUTCDate() === 29;
            if(yearMatches&&monthMatches&&dayMatches) setDays(getDays(29));
            else setDays(getDays(28));
        }else if(chosenDate.month===6 ||chosenDate.month===9 ||chosenDate.month===11 ||chosenDate.month===4) {
            setDays(getDays(30));
        } else {
            setDays(getDays(31));
        }
        setChosenDate(previous=>({...previous, day:""}));
    }, [chosenDate.year, chosenDate.month])

    const chooseUrl = (daysBetween, gift=false) =>{
        let nextURL="";
        if (daysBetween <= 41) {
            nextURL = "/subscribe-otb?choice=0-0"; 
        } else if (daysBetween > 41 && daysBetween <= 56) {
            nextURL = "/subscribe-plans/?choice=1-1";
        } else if (daysBetween > 56 && daysBetween <= 71) {
            nextURL = "/subscribe-plans/?choice=1-2";
        } else if (daysBetween > 71 && daysBetween <= 82) {
            nextURL = "/subscribe-plans/?choice=1-3";
        }else if (daysBetween > 82 && daysBetween <= 112) {
            nextURL = "/subscribe-plans/?choice=1-5";
        } else if (daysBetween > 112 && daysBetween <= 144) {
            nextURL = "/subscribe-plans/?choice=2-2";
        } else if (daysBetween > 144 && daysBetween <= 173) {
            nextURL = "/subscribe-plans/?choice=2-3";
        } else if (daysBetween > 173 && daysBetween <= 206) {
            nextURL = "/subscribe-plans/?choice=2-4";
        } else if (daysBetween > 206 && daysBetween <= 234) {
            nextURL = "/subscribe-plans/?choice=3-1";
        } else if (daysBetween > 234 && daysBetween <= 264) {
            nextURL = "/subscribe-plans/?choice=3-2";
        } else if (daysBetween > 264 && daysBetween <= 358) {
            nextURL = "/subscribe-plans/?choice=3-3";
        } else if (daysBetween > 358 && daysBetween <= 538) {
            nextURL = "/subscribe-plans/?choice=3-4";
        } else if (daysBetween > 538) {
            nextURL = "/subscribe-plans/?choice=3-5";
        }
        if(nextURL){
            return nextURL;
        }else {
            return null;
        }
        
    }
    return(
        <Grid container className="subscribe-container">
            <Grid container item xs={11} justifyContent="center">
                <Title title={title} description={subTitle} img="yes" src={require('../../imgs/ring.png')} alt="ring" style={{width: '120px', marginBottom: "15px"}}></Title>
            </Grid>
            <Grid container item xs={11} md={9} justifyContent="center" >
                <Grid container item xs={12} md={5} xl={3} spacing={1} justifyContent="center" style={{maxWidth:"376px"}}>
                    <Grid item xs={3.5} >
                        <InputSelect label="Year" data={years} no_error={"yes"} value={chosenDate.year} 
                        onChange={(e)=>{setChosenDate({...chosenDate, year:e.target.value});}} ></InputSelect>
                    </Grid>
                    <Grid item xs={5}>
                        <InputSelect label="Month" data={months} no_error={"yes"} value={chosenDate.month} 
                        onChange={(e)=>{setChosenDate({...chosenDate, month:e.target.value})}}></InputSelect>
                    </Grid>
                    <Grid item xs={3.5} id="the-last-input">
                        <InputSelect label="Day" data={days} no_error={"yes"} value={chosenDate.day} 
                        onChange={(e)=>{setChosenDate({...chosenDate, day:e.target.value})}}></InputSelect>
                    </Grid>
                </Grid>
            </Grid>
            <Grid container item xs={11} md={9} spacing={1} justifyContent="center">
                <Grid item xs={12} md={5} xl={3} style={{maxWidth:"376px"}}>
                        <Button text="CONTINUE" href={url} onClick={()=>{if(!url) addError(document.getElementById("the-last-input"), `Please enter the wedding date, or click the "No Date" button`);}}></Button>
                        <Button 
                            className="btn-reverse" 
                            text={gift?"I don't know the date":"WE HAVE NOT DECIDED YET"}
                            onClick={()=>{
                                window.location.href = `/subscribe-plans/?choice=3-6&${urlParams.toString()}`
                            }}></Button>
                </Grid>
            </Grid>
        </Grid>
        )
}